<template>
  <section id="toasts">
    <div class="demo">
      <button class="btn btn-ctrl" :disabled="disabled" v-on:click="trigger" >Trigger</button>
      <div role="alert" aria-live="assertive" aria-atomic="true" class="toast toast-info" v-bind:class="{'slide-in':toastActive, 'fade-out':toastHidden}">
          Informational messages 
          <a href="" title="an example link" class="toast-link">an example link</a>
          <button type="button" id="" class="btn close" title="Close" aria-label="Close" v-on:click="trigger">
              <i aria-hidden="true" class="gel-icon-close gel-icon-lg"></i>
          </button>
      </div>
      <div role="alert" aria-live="assertive" aria-atomic="true" class="toast toast-success"  v-bind:class="{'slide-in':toastActive, 'fade-out':toastHidden}" style="top: 10rem">
          The invitation to candidate has been sent
          <a href="" title="an example link" class="toast-link">an example link</a>
          <button type="button" id="" class="btn close" title="Close" aria-label="Close" v-on:click="trigger" >
              <i aria-hidden="true" class="gel-icon-close gel-icon-lg"></i>
          </button>
      </div>
      <div role="alert" aria-live="assertive" aria-atomic="true" class="toast toast-danger" v-bind:class="{'slide-in':toastActive, 'fade-out':toastHidden}" style="top: 16rem">
          Something went wrong in bulk action
          <a href="" title="an example link" class="toast-link">an example link</a>
          <button type="button" id="" class="btn close" title="Close" aria-label="Close" v-on:click="trigger">
              <i aria-hidden="true" class="gel-icon-close gel-icon-lg"></i>
          </button>
      </div>
      <div role="alert" aria-live="assertive" aria-atomic="true" class="toast toast-warning" v-bind:class="{'slide-in':toastActive, 'fade-out':toastHidden}" style="top: 22rem">
           A simple primary toast with an example
          <a href="" title="an example link" class="toast-link">an example link</a>
          <button type="button" id="" class="btn close" title="Close" aria-label="Close" v-on:click="trigger">
              <i aria-hidden="true" class="gel-icon-close gel-icon-lg"></i>
          </button>
      </div>
    </div>
    <section class="md" v-html="mdfile"></section>
  </section>
</template>

<script>
import mdfile from "@/docs/components/toasts.md";
export default {
  name: "toasts",
  beforeCreate: function() {
    this.$emit("update-title", this.$root.yamlData.components.toasts.name);
    this.$emit(
      "update-tagline",
      this.$root.yamlData.components.toasts.description
    );
  },
  data() {
    return {
      mdfile,
      toastActive: false,
      toastHidden: false,
    };
  },
  methods: {
    trigger: function(){
      this.disabled = true;
      this.toastActive = !this.toastActive;
      this.delay();
    },
    delay:function(){
      setTimeout(()=>{
        this.toastHidden = true;
      },5000);
      setTimeout(()=>{
        this.toastActive = false;
      },6000);
      setTimeout(()=>{
        this.toastHidden = false;
        this.disabled = false;
      },7000);
    }
  }
};
</script>
